import __request__ from 'routing/request';
interface CapabilitiesResource__CapabilitiesResponse {
    readonly capabilities: CapabilitiesResource__CapabilityDescriptorResponse[];
}
interface CapabilitiesResource__CapabilityPermissionsResponse {
    readonly capability: 'view' | 'manage' | 'own';
    readonly permissions: string[];
    readonly entity: string;
}
interface CapabilitiesResource__CapabilityDescriptorResponse {
    readonly capability: 'view' | 'manage' | 'own';
    readonly permissions: {
        readonly [_key: string]: string[];
    };
    readonly title: string;
}
/**
 * Return a list of all capabilities in the system
 */
export function list(): Promise<CapabilitiesResource__CapabilitiesResponse> {
    return __request__('GET', '/authz/capabilities', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Return the requested capability
 * @param capability capability
 */
export function get(capability?: string): Promise<CapabilitiesResource__CapabilityDescriptorResponse> {
    return __request__('GET', `/authz/capabilities/${capability}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get permissions for a specific capability and entity
 * @param capability capability
 * @param entity entity
 */
export function entityCapabilityPermissions(capability?: string, entity?: string): Promise<CapabilitiesResource__CapabilityPermissionsResponse> {
    return __request__('GET', `/authz/capabilities/${capability}/${entity}`, null, {}, {
        'Accept': ['application/json']
    });
}
